export default "__VITE_ASSET__CNJFN90x__"